export default __webpack_public_path__ + "8941753e0c5ae7ab7addb1913b8c5dbe.png";